import type { DiscountFactor } from '../types'

/** Root category ID for promo products */
export const CATEGORY_ID = '1211'

/** CMS block identifier for promo banner */
export const CMS_BLOCK_IDENTIFIER = 'cart_promo_banner1'

/** Cart total thresholds for discount levels */
export const PROMOTION_LEVELS = [500, 1000] as const

/** Discount factors by tier (multiplied with regular price) */
export const DISCOUNTS = {
  1: 0.5,
  2: 0.3,
  3: 0.1,
} as const

/** Human-readable discount labels per factor */
export const DISCOUNT_LABELS: Readonly<Record<number, string>> = {
  [DISCOUNTS[1]]: 'Pana la 50% reducere in cos!',
  [DISCOUNTS[2]]: 'Pana la 70% reducere in cos!',
  [DISCOUNTS[3]]: 'Pana la 90% reducere in cos!',
}

/** Polling interval for cart localStorage updates (ms) */
export const CART_POLL_INTERVAL_MS = 1500

/**
 * Get discount label for a given factor
 */
export function getDiscountLabel(factor: DiscountFactor): string {
  return DISCOUNT_LABELS[factor] ?? 'Pana la 50% reducere in cos!'
}
